export class Tooltip {
    private tooltip: HTMLElement;
    private tooltipArrow: HTMLElement;
    private tooltipInner: HTMLElement;
    private tooltipTimeout: any = null;

    constructor(public parentNode: HTMLElement,
        public eventNode: HTMLElement,
        public boundingNode: HTMLElement,
        public text: string,
        public alwaysTooltip: boolean
    ) {
        this.tooltip = document.createElement('div');
        this.tooltip.style.display = 'none';
        this.tooltip.className = 'tooltip top hd-ellipsis-tooltip fade';
        this.tooltipArrow = document.createElement('div');
        this.tooltipArrow.className = 'tooltip-arrow';
        this.tooltipInner = document.createElement('div');
        this.tooltipInner.className = 'tooltip-inner';
        this.tooltipInner.innerText = text;
        this.tooltip.appendChild(this.tooltipArrow);
        this.tooltip.appendChild(this.tooltipInner);

        if (eventNode !== null) {
            eventNode.onmouseout = this.mouseOut;
            eventNode.onmouseover = this.mouseOver;
        }
        if (parentNode !== null) {
            parentNode.appendChild(this.tooltip);
        }
    }

    public getElement = (): HTMLElement => this.tooltip;

    public mouseOver = () => {
        if (this.tooltipTimeout != null) {
            clearTimeout(this.tooltipTimeout);
            this.tooltipTimeout = null;
        }
        this.tooltipTimeout = setTimeout(this.show, 250);
    };

    public mouseOut = () => {
        if (this.tooltipTimeout != null) {
            clearTimeout(this.tooltipTimeout);
            this.tooltipTimeout = null;
        }
        this.tooltipTimeout = setTimeout(this.hide, 50);
    };

    private show = () => {

        if (this.eventNode.clientWidth < this.eventNode.scrollWidth || this.alwaysTooltip) {
            $(this.tooltip).addClass('fade');
            if ($(this.tooltip).hasClass('out')) {
                $(this.tooltip).removeClass('out');
            }
            // css for tooltip in file manager
            $(this.tooltip).addClass('in');
            this.tooltip.style.display          = 'inline';
            this.tooltip.style.opacity          = '1';
            this.tooltip.style.position         = 'absolute';
            this.tooltip.style.zIndex           = '1';
            this.tooltip.style.color            = '#fff';
            this.tooltip.style.backgroundColor  = 'black';
            this.tooltip.style.maxWidth         = '200px';
            this.tooltip.style.wordBreak        = 'break-word';
            this.tooltip.style.borderRadius     = '5px';
            this.tooltip.style.top              = '-100px';
            this.tooltip.style.padding          = '5px';
                
            const boundingNodeRect = this.boundingNode.getBoundingClientRect();
            const eventNodeRect = this.eventNode.getBoundingClientRect();

            const specificDiv = this.tooltip.querySelector('.tooltiparrow');
            if (specificDiv) {
                this.tooltip.removeChild(specificDiv);
            }

            // css for tooltip arrow
            const arrow = document.createElement('div');
            arrow.className = 'tooltiparrow';
            arrow.style.content = ' ';
            arrow.style.position = 'absolute';
            arrow.style.left = '50%';
            arrow.style.marginLeft = '-5px';
            arrow.style.borderWidth = '5px';
            arrow.style.borderStyle = 'solid';

            if (eventNodeRect.top - boundingNodeRect.top < this.tooltip.scrollHeight) {
                this.tooltip.style.top = this.eventNode.offsetTop + this.eventNode.clientHeight + 'px';
                arrow.style.top = '-9px'; // Adjust the value for spacing
                arrow.style.borderColor = 'transparent transparent black transparent'; // Change the border color
            } 
            else {
                this.tooltip.style.top = this.eventNode.offsetTop - this.tooltip.scrollHeight + 'px';
                arrow.style.top = '100%';
                arrow.style.borderColor = 'black transparent transparent transparent';  
            }
            this.tooltip.appendChild(arrow);
            this.tooltip.style.left = (this.eventNode.offsetLeft + ((this.eventNode.clientWidth - this.tooltip.clientWidth) / 2) | 0) + 'px';
        }
        this.tooltipTimeout = null;
    };
    
    private hide = () => {
        if ($(this.tooltip).hasClass('in')) {
            $(this.tooltip).removeClass('in');
            $(this.tooltip).addClass('out');
            this.tooltipTimeout = setTimeout(() => {
                this.tooltip.style.display = 'none';
                this.tooltipTimeout = null;
            }, 150);
        }
    };
}
